"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _constants = require("./constants");

var _menuOptionsContainer = _interopRequireDefault(require("../../utils/common-portal/menu-options-container"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _io = require("react-icons/io5");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-select-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 2.5rem;\n  border: 0.0625rem solid #a8a8a8;\n  border-radius: 0.125rem;\n  padding: 0.4375rem 0.9375rem;\n  box-sizing: border-box;\n  background-color: #ffffff; }\n\n.bds-select-container-focus:focus-within {\n  border: 0.125rem solid #067fdb;\n  padding: 0.375rem 0.875rem; }\n\n.bds-select-small-container {\n  height: 2rem;\n  border: 0.0625rem solid #a8a8a8;\n  padding: 0.3125rem 0.4375rem 0.375rem 0.4375rem;\n  box-sizing: border-box; }\n\n.bds-select-small-container-focus:focus-within {\n  border: 0.125rem solid #067fdb;\n  padding: 0.25rem 0.375rem 0.3125rem 0.375rem; }\n\n.bds-select-small-value-wrapper {\n  display: flex;\n  height: 1.1875rem;\n  align-items: center; }\n\n.bds-select-small-actions-container {\n  display: flex;\n  align-items: center; }\n\n.bds-select-container-inline {\n  border: none; }\n\n.bds-select-container-disabled {\n  border: 0.0625rem solid #c6c6c6; }\n  .bds-select-container-disabled .bds-select-placeholder {\n    color: #c6c6c6; }\n\n.bds-select-container-error {\n  border: 0.125rem solid #da1e28;\n  padding: 0.4375rem 0.9375rem; }\n\n.bds-select-container-read-only {\n  border: none;\n  padding: 0;\n  height: 19px; }\n\n.bds-select-container-disabled-inline {\n  border: none; }\n\n.bds-select-error-message {\n  text-align: left;\n  font-size: 12px;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.0625rem;\n  margin-top: 0.0625rem;\n  color: #da1e28; }\n\n.bds-select-actions-container {\n  display: flex; }\n\n.bds-select-actions-container-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-left: 1rem; }\n\n.bds-select-actions-small-container-item {\n  display: flex;\n  align-items: center;\n  margin-left: 0.5rem; }\n\n.bds-select-label {\n  height: 1.1875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #393939;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600; }\n\n.bds-select-label-read-only {\n  margin-bottom: 0.5rem; }\n\n.bds-select-label-disabled {\n  color: #c6c6c6; }\n\n.bds-select-helper-text {\n  height: 1.0625rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #6f6f6f;\n  font-size: 0.75rem;\n  margin-bottom: 0.25rem; }\n\n.bds-select-helper-text-disabled {\n  color: #c6c6c6; }\n\n.bds-select-value {\n  width: 100%;\n  height: 1.1875rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #393939;\n  margin-bottom: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.bds-select-value-disabled {\n  color: #c6c6c6; }\n\n.bds-select-value-read-only {\n  text-align: left;\n  font-size: 0.875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #525252; }\n\n.bds-select-placeholder {\n  color: #8d8d8d; }\n\n.bds-select-options-container {\n  max-height: 20rem;\n  border: 0.0625rem solid #067fdb;\n  box-sizing: border-box;\n  overflow: auto; }\n\n.bds-select-option {\n  display: flex;\n  align-items: center;\n  padding-left: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  box-sizing: border-box;\n  height: 2.5rem;\n  cursor: pointer; }\n  .bds-select-option:hover {\n    background: #e0e0e0; }\n\n.bds-select-option-label {\n  display: flex;\n  align-items: center;\n  height: 1.1875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #393939;\n  font-size: 0.875rem; }\n\n.bds-select-icon {\n  color: #6f6f6f; }\n\n.bds-select-icon-disabled {\n  color: #c6c6c6; }\n";
  var fileName = "compone_select";
  var element = document.querySelector("style[data-sass-component='compone_select']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Select = function Select(_ref) {
  var _labelClasses, _helperTextClasses, _containerClasses, _selectValueClasses, _actionsContainerItem, _selectRef$current;

  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      label = _ref.label,
      helperText = _ref.helperText,
      onChange = _ref.onChange,
      getOptionLabel = _ref.getOptionLabel,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      width = _ref.width,
      value = _ref.value,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      placeholder = _ref.placeholder,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      onBlur = _ref.onBlur,
      _ref$disablePortal = _ref.disablePortal,
      disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip,
      height = _ref.height;
  var optionSelected = Boolean(value) ? value : null;

  var _useState = (0, _react.useState)(optionSelected),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showOptions = _useState4[0],
      setShowOptions = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      containerDimension = _useState6[0],
      setContainerDimension = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      enableTooltip = _useState8[0],
      setEnableTooltip = _useState8[1];

  var selectRef = (0, _react.useRef)();
  var selectedValueRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setSelectedValue(optionSelected);
  }, [value]);
  (0, _react.useEffect)(function () {
    handleTooltipVisibility();
  }, [selectedValue]);

  var handleTooltipVisibility = function handleTooltipVisibility() {
    var element = selectedValueRef.current;

    if (showTooltip && selectedValue && element) {
      setEnableTooltip(element.scrollWidth > element.clientWidth);
    } else {
      setEnableTooltip(false);
    }
  };

  var getContainerDimension = function getContainerDimension() {
    var rect = selectRef.current.getBoundingClientRect();
    var dimension = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      height: rect.height
    };
    setContainerDimension(dimension);
  };

  var showSuggestions = function showSuggestions() {
    getContainerDimension();
    setShowOptions(!showOptions);
  };

  var selectedValueClickHandler = function selectedValueClickHandler() {
    if (!(disabled || readOnly)) {
      showSuggestions();
    }
  };

  var selectedValueKeyDownHandler = function selectedValueKeyDownHandler(event) {
    if (event.code === 'Enter') {
      if (!(disabled || readOnly)) {
        showSuggestions();
      }
    }
  };

  var blurHandler = function blurHandler(e) {
    setShowOptions(false);
    onBlur && onBlur(e);
  };

  var selectOption = function selectOption(event, value) {
    setShowOptions(false);
    setSelectedValue(value);
    onChange(event, value);
  };

  var labelClasses = (_labelClasses = {}, _defineProperty(_labelClasses, _constants.classes.selectLabel, true), _defineProperty(_labelClasses, _constants.classes.selectLabelDisabled, disabled), _labelClasses);
  var helperTextClasses = (_helperTextClasses = {}, _defineProperty(_helperTextClasses, _constants.classes.selectHelperText, true), _defineProperty(_helperTextClasses, _constants.classes.selectHelperTextDisabled, disabled), _helperTextClasses);
  var containerClasses = (_containerClasses = {}, _defineProperty(_containerClasses, _constants.classes.container, true), _defineProperty(_containerClasses, _constants.classes.selectContainerFocus, !(disabled || readOnly) && size !== 'small'), _defineProperty(_containerClasses, _constants.classes.selectContainerDisabled, disabled && !inline), _defineProperty(_containerClasses, _constants.classes.selectContainerDisabledInline, disabled && inline), _defineProperty(_containerClasses, _constants.classes.selectContainerInline, !disabled && inline), _defineProperty(_containerClasses, _constants.classes.selectContainerError, errorMessage), _defineProperty(_containerClasses, _constants.classes.selectContainerReadOnly, readOnly), _defineProperty(_containerClasses, _constants.classes.selectSmallContainerFocus, size === 'small'), _defineProperty(_containerClasses, _constants.classes.selectSmallContainer, size === 'small'), _containerClasses);
  var selectValueClasses = (_selectValueClasses = {}, _defineProperty(_selectValueClasses, _constants.classes.selectValue, true), _defineProperty(_selectValueClasses, _constants.classes.selectPlaceholder, !selectedValue && !readOnly), _defineProperty(_selectValueClasses, _constants.classes.selectValueDisabled, disabled), _defineProperty(_selectValueClasses, _constants.classes.selectValueReadOnly, readOnly), _defineProperty(_selectValueClasses, _constants.classes.selectSmallValueWrapper, size === 'small'), _selectValueClasses);
  var actionsContainerItemClasses = (_actionsContainerItem = {}, _defineProperty(_actionsContainerItem, _constants.classes.actionsContainerItem, true), _defineProperty(_actionsContainerItem, _constants.classes.selectActionsSmallContainerItem, size === 'small'), _actionsContainerItem);

  var renderSelectedValue = function renderSelectedValue() {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "select-value",
      className: (0, _classnames.default)(_objectSpread({}, selectValueClasses)),
      onClick: selectedValueClickHandler,
      onKeyDown: selectedValueKeyDownHandler,
      tabIndex: _constants.defaultTabIndex,
      ref: selectedValueRef
    }, selectedValue ? getOptionLabel(selectedValue) : readOnly ? 'None' : placeholder);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, labelClasses))
  }, label), !readOnly && helperText && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, helperTextClasses))
  }, helperText), /*#__PURE__*/_react.default.createElement("div", {
    ref: selectRef,
    className: (0, _classnames.default)(_objectSpread({}, containerClasses)),
    style: {
      width: width,
      height: height
    },
    tabIndex: _constants.defaultTabIndex,
    onBlur: blurHandler,
    "data-testid": _constants.classes.container
  }, enableTooltip && showTooltip ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: getOptionLabel(selectedValue),
    position: "top",
    className: "select-value-tooltip"
  }, renderSelectedValue()) : renderSelectedValue(), !readOnly && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.actionsContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, actionsContainerItemClasses)),
    onClick: selectedValueClickHandler,
    onKeyDown: selectedValueKeyDownHandler,
    tabIndex: _constants.defaultTabIndex
  }, showOptions ? /*#__PURE__*/_react.default.createElement(_io.IoChevronUp, {
    className: disabled ? _constants.classes.selectIconDisabled : _constants.classes.selectIcon,
    size: size === 'small' ? _constants.smallIconSize : _constants.defaultIconSize
  }) : /*#__PURE__*/_react.default.createElement(_io.IoChevronDown, {
    className: disabled ? _constants.classes.selectIconDisabled : _constants.classes.selectIcon,
    size: size === 'small' ? _constants.smallIconSize : _constants.defaultIconSize
  })))), showOptions && /*#__PURE__*/_react.default.createElement(_menuOptionsContainer.default, {
    portalContainerId: 'dropdown-components',
    containerDimension: containerDimension,
    width: (selectRef === null || selectRef === void 0 ? void 0 : (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.offsetWidth) || width,
    options: options,
    onChange: selectOption,
    getOptionLabel: getOptionLabel,
    disablePortal: disablePortal
  }), error ? /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.selectErrorMessage,
    style: {
      width: width
    }
  }, errorMessage) : null);
};

Select.propTypes = {
  options: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func.isRequired,
  getOptionLabel: _propTypes.default.func.isRequired,
  width: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  label: _propTypes.default.string,
  helperText: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  placeholder: _propTypes.default.string,
  size: _propTypes.default.string,
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  height: _propTypes.default.string
};
var _default = Select;
exports.default = _default;